// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionSave = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M16.947 8.936l-.817-.878A.172.172 0 0016 8a.165.165 0 00-.13.058l-5.666 5.963-2.062-2.154a.18.18 0 00-.13-.059.18.18 0 00-.13.059l-.826.863a.2.2 0 000 .277l2.6 2.716c.167.175.372.277.544.277.246 0 .46-.19.538-.267h.005l6.209-6.52c.065-.083.065-.204-.005-.277z" />
      <path d="M12 3.346c2.313 0 4.486.9 6.12 2.534A8.597 8.597 0 0120.654 12a8.597 8.597 0 01-2.534 6.12A8.597 8.597 0 0112 20.654a8.597 8.597 0 01-6.12-2.534A8.597 8.597 0 013.346 12c0-2.313.9-4.486 2.534-6.12A8.597 8.597 0 0112 3.346zM12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2z" />
    </g>
  </svg>
);

export default ActionSave;
